const baseFitmentFields = ['Year', 'Make', 'Model', 'Submodel'];
const extraFitmentFields = ['Drive', 'Engine', 'EngineFuelType', 'BodyType', 'BodyDoor'];

const categorySelectionPageUrl = '/category-listing/';
const brandSelectionPageUrl = '/brand-list/';

const doNotRedirectOnVehicleSelect =
  window.location.pathname === '/search/' ||
  document.querySelector('#product-listing-container-main.page-content--category') ||
  document.querySelector('.productView[data-entity-id]');

window.Convermax.changeVehicleInDialog = () => {
  window.document
    .querySelector('.cm_vehicle-widget__dialog .cm_vehicle-widget_dropdowns')
    .classList.remove('cm_hide');

  window.document
    .querySelector('.cm_vehicle-widget__dialog .cm_vehicle-widget_label')
    .classList.add('cm_hide');
};

window.Convermax.categoryTitle = [...window.document.querySelectorAll('ol.breadcrumbs .breadcrumb span')]
  .map((el) => el.textContent)
  .at(-1);

function InitFunc() {
  if (window.document.querySelector('#cm_results, #cm-brand-list, #cm_manufacturers')) {
    const unwantedPageWrappers = [
      ['.page-content.page-content--centered', 'page-content--centered'],
      ['.page-content', 'page-content'],
    ];

    unwantedPageWrappers.forEach(([elemSelector, className]) => {
      const wrapperElem = window.document.querySelector(elemSelector);
      wrapperElem?.classList.remove(className);
    });
  }
}

function getLocalPreselection(pageType, defaults) {
  const isCategoryPage = pageType === 'category';
  const isBrandPage = pageType === 'brand';

  if (
    (isCategoryPage || isBrandPage) &&
    defaults.termFromBreadcrumbs !== 'Home' &&
    defaults.termFromBreadcrumbs?.startsWith('Home')
  ) {
    const breadcrumbsSelector = '.breadcrumbs .breadcrumb, .breadcrumbs .breadcrumb-text';

    const parseBreadcrumbs = (...elements) => {
      const isMetaFromZero = elements.some((el) => el.querySelector('meta')?.getAttribute('content') === '0');

      return elements
        .map((elem) => {
          const elemFirstChild = elem.firstElementChild;
          const text = (elemFirstChild.textContent || elemFirstChild.innerText).trim();
          const metaAttr = elemFirstChild.querySelector('meta')?.getAttribute('content');
          const ignore =
            text.toLowerCase() === 'home' || (isMetaFromZero ? metaAttr === '0' : metaAttr === '1');
          return !ignore && text;
        })
        .filter(Boolean);
    };

    const getTermFromBreadcrumbs = () =>
      parseBreadcrumbs(...window.document.querySelectorAll(breadcrumbsSelector)).join('>');

    const trimmedTermFromBreadcrumbs = getTermFromBreadcrumbs();

    return [
      {
        field: isCategoryPage ? 'category' : 'brand_name',
        term: trimmedTermFromBreadcrumbs,
        treeLevel: isCategoryPage ? trimmedTermFromBreadcrumbs.split('>').length - 1 : null,
      },
    ];
  }

  return defaults.getter(pageType);
}

const onVerifyFitmentResponseReceived = (response) => {
  const addToCartButton = window.document.querySelector('.add-to-cart-buttons .button');

  const soldOut =
    document.querySelector('#alertBox-message-text')?.textContent === 'This item is currently out of stock';

  if (!soldOut && addToCartButton) {
    const fits = response.Items?.[0]?.fitsTheVehicle;

    if (fits && fits === 'no') {
      addToCartButton.setAttribute('disabled', 'true');
    } else if (!soldOut) {
      addToCartButton.removeAttribute('disabled', 'true');
    }
  }
};

export default {
  platform: 'bigcommerce',
  InitFunc,
  getLocalPreselection,
  page: {
    getPageType: (defaults) =>
      document.querySelector('#product-listing-container-main.page-content--category')
        ? 'category'
        : window.location.pathname === categorySelectionPageUrl ||
            window.location.pathname === brandSelectionPageUrl
          ? 'parts'
          : defaults.getter(),
  },
  SearchRequestDefaults: {
    pageSize: 12,
    sort: 'relevance',
  },
  pagination: {
    centralRange: 3,
    edgeRange: 1,
  },
  autocomplete: {
    order: ['text', 'facetValue', 'product'],
  },
  product: {
    searchResultsImageWidth: 380,
    searchResultsImageHeight: 380,
  },
  fitmentSearch: {
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
    categorySelectionPages: [
      { pathname: categorySelectionPageUrl, field: 'category' },
      { pathname: brandSelectionPageUrl, field: 'brand_name' },
    ],
    isAutoRedirectDisabled: true,
    isExtraFieldsAlwaysVisible: true,
    forceSpecifyDialog: true,
    onVerifyFitmentInitResponseReceived: onVerifyFitmentResponseReceived,
    onVerifyFitmentResponseReceived,
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: '#cm_results',
      template: 'MainContent',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: {
        selector: '#product-listing-container-main.page-content--category',
        class: 'cm_category-page__container',
      },
      template: 'MainContent',
      visibleIf: () => window.location.pathname !== categorySelectionPageUrl,
    },
    {
      name: 'CategoryPageCategoriesCarousel',
      type: 'FacetTiles',
      template: 'facetTiles/subtitles',
      view: 'carousel',
      facetField: 'category',
      visibleIf: () => !window.location.pathname.includes('/search/'),
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
    },
    {
      name: 'SearchResult',
    },
    {
      name: 'SearchHeader',
      sortEntries: {
        'relevance': 'Best Match',
        'collection_sort': 'Featured',
        'price': 'Price, Low to High',
        'price:desc': 'Price, High to Low',
      },
      sortSelectClass: 'form-select form-select--small',
    },
    {
      name: 'SearchPageHeader',
      type: 'SearchPage', // to provide access to query and total hits
      location: '.page-heading',
      template: 'SearchPageHeader',
      visibleIf: () => window.location.pathname === '/search/',
    },
    {
      name: 'SearchBox',
      location: { selector: '.navUser-item.navUser-item--quickSearch', class: 'cm-search-box' },
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxMobile',
      type: 'SearchBox',
      location: {
        replace: '.header-actions #quick-search-expand',
        class: 'cm-mobile-search-box',
      },
      template: 'SearchBox',
    },
    {
      name: 'SingleVehicleGarage',
      location: {
        replace: '.navUser-item.navUser-item--vehicle .add-your-vehicle',
        class: 'cm_single-vehicle-garage',
      },
      template: 'fitmentSearch/singleVehicleGarage',
    },
    {
      name: 'SingleVehicleGarageMobile',
      type: 'SingleVehicleGarage',
      location: {
        replace: '.header-actions .navUser-item.navUser-item--vehicle .add-your-vehicle',
        class: 'cm_single-vehicle-garage',
      },
      template: 'fitmentSearch/singleVehicleGarage',
    },
    {
      name: 'HomeVehicleWidget',
      type: 'VehicleWidget',
      location: {
        insertAfter: '[data-content-region="homepage_main"] site-hero',
      },
      template: 'fitmentSearch/homeVehicleWidget',
      columnBreakpoint: 1000,
      fields: baseFitmentFields,
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      columnBreakpoint: 1000,
      fields: baseFitmentFields,
      isAlwaysActive: true,
    },
    {
      name: 'SearchVehicleWidget_label',
      type: 'VehicleWidget',
    },
    {
      name: 'VerifyFitment',
      location: '.productView .productView-vehicle',
      template: 'fitmentSearch/verifyFitment',
    },
    {
      name: 'FitmentTable',
      location: {
        insertAfter: 'product-details #tab-description',
        class: 'tab-content tab-fitments cm_fitment-table-tab',
        id: 'tab-fitments',
      },
      template: 'fitmentSearch/fitmentTable',
      columnBreakpoint: 1200,
    },
    {
      name: 'FitmentTableTab',
      type: 'FitmentTable',
      location: {
        insertAfter: 'product-details .swiper-wrapper.tabs--description .tab',
        wrapperElem: 'li',
        class: 'swiper-slide tab cm_fitment-table-tab',
      },
      template: 'fitmentSearch/fitmentTableTab',
    },
    {
      name: 'FacetBrandTiles',
      type: 'FacetTiles',
      location: '#cm-brand-list',
      template: 'facetTiles/alphabeticalContainer',
      isAlwaysActive: true,
      view: 'grid',
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
      initCollapsed: false,
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
    {
      name: 'VehicleWidgetDialog',
      template: 'fitmentSearch/dialog',
      doNotRedirectOnVehicleSelect,
      globalVehicleDiscardEnabled: true,
      isAlwaysColumnLayout: true,
    },
  ],
};
